const dialog = require('../../../../../components/dialog/dialog')
const dtHandler = require('../../../../../components/dt/dt-handler')

const inventoryConflictColumns = [
      { key: 'item', label: 'Item', behavior: false, displayText: true },
      { key: 'restore_qty', label: 'Qty to Restore', behavior: false, displayText: true },
      { key: 'available_qty', label: 'Current Inventory', behavior: false, displayText: true },
]

export function start(detail) {
      const body = dialogBody[detail.id]

      if (!body) { return }

      body.start(detail)
      dialog.start({ ...detail, html: body })
}

const dialogBody = {
      inventoryRestoreConflict: {
            title: '',
            des: '',
            bodyHtml: '',
            primary: {
                  text: 'Close',
                  class: 'button primary',
                  dataDetail: `data-detail='{"click": [
                    {"dest":"ripple"}, {"dest":"dialog", "act":"hide"}
                  ]}'`,
            },
            secondary: { text: '', class: 'button secondary button-plain', dataDetail: '' },
            tertiary: { text: '', class: 'button secondary button-plain', dataDetail: '' },
            start(detail) {
                  const items = Array.isArray(detail.items) ? detail.items : []
                  this.title = 'Retail cannot be restored'
                  this.des = ''
                  this.bodyHtml = `
                    <label class="font-body2-red mb-16">
                      The Retail invoice was not restored because the current inventory is lower than the quantity required by the deleted invoice.
                    </label>
                    ${dtHandler.dtSimpleFc(inventoryConflictRows(items), inventoryConflictColumns)}
                  `
            },
      },
}

function inventoryConflictRows(items) {
      return items.map((item) => ({
            item: escapeHtml(
                  [item.item_code, item.item_name].filter(Boolean).join(' - '),
            ),
            restore_qty: formatQuantity(item.restore_qty),
            available_qty: formatQuantity(item.available_qty),
      }))
}

function formatQuantity(value) {
      const quantity = Number(value)
      if (!Number.isFinite(quantity)) { return '0' }

      return Number.isInteger(quantity) ? String(quantity) : quantity.toFixed(2)
}

function escapeHtml(value) {
      return String(value ?? '')
            .replaceAll('&', '&amp;')
            .replaceAll('<', '&lt;')
            .replaceAll('>', '&gt;')
            .replaceAll('"', '&quot;')
            .replaceAll("'", '&#039;')
}
